/**
 * genericErrorModal.tsx
 */
import Buttons from '../../elements/modal/genericErrorModalButtons';
import Container from '../../atoms/container/modalContainer';
import Error from '../../atoms/container/errorContainer';
import Subtitle from '../../atoms/text/modalSubtitle';
import Title from '../../atoms/text/modalTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { modalSelector } from '@shared/store/slices/modal.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Displays the generic error modal.
 */
export default function GenericErrorModal() {
  const { params } = useAppSelector(modalSelector);
  const title =
    (params.title as string) ||
    TranslationManager.get('MODAL.GENERIC_ERROR.TITLE');
  return (
    <Container>
      <Error>
        <Title color={params.titleColor as string}>{title}</Title>
        <Subtitle width={params.textWidth as string}>
          {(params.text || '') as string}
        </Subtitle>
        <Buttons />
      </Error>
    </Container>
  );
}
